export default __webpack_public_path__ + "static/media/minivistaw-recomendaciones.418b71e0.jpg";